import React from 'react'
import { withTranslation } from 'react-i18next'

import EmptyBlock from 'app/components/EmptyBlock'
import Button from 'app/components/ButtonDefault'
import WhyYouStopProTrackPopup from './WhyYouStopProTrackPopup'
import WhyYouChangeProTrack from 'app/domains/common/WhyYouChangeProTrack'
import { PROCEED } from 'app/constants/stages'

import './styles.scss'
const baseClass = 'active-pro-tracks'

const ActiveProTracks = ({
  t,
  stage,
  proTrackNameWithLevelName,
  showModal,
  goToSelectProTrack,
  hasAbilityToSelectNewProTrack,
  isUserCanSwitchProtrack,
}) => {
  if (!hasAbilityToSelectNewProTrack) {
    return <div className={`${baseClass}__title`}>{t('You have finished all available ProTracks')}</div>
  }
  if (stage !== PROCEED) {
    return (
      <EmptyBlock
        title={t('No Active ProTrack Selected')}
        btnText={t('Select New ProTrack')}
        onAdd={goToSelectProTrack}
      />
    )
  }
  return (
    <div className={baseClass}>
      <span>
        {t('Active ProTrack')}: <span className={`${baseClass}__name`}>{proTrackNameWithLevelName}</span>
      </span>
      <div className={`${baseClass}__buttons`}>
        {isUserCanSwitchProtrack && (
          <Button sm onClick={() => showModal(WhyYouChangeProTrack)}>
            {t('Choose Another ProTrack')}
          </Button>
        )}
        <Button className={`${baseClass}__button`} sm remove onClick={() => showModal(WhyYouStopProTrackPopup)}>
          {t('Stop ProTrack')}
        </Button>
      </div>
    </div>
  )
}

export default withTranslation('user')(ActiveProTracks)
